import React from "react";
import { apiEndpoints } from "../../config";

// Modules
import PostAdd from "../../partials/posts/postAdd";

export default function AddPodcast(props) {
  return(
    <PostAdd 
      targetVid={"podcast_categories"}
      addPostEndpoint={apiEndpoints.podcasts}
      editRoute={"/podcasts/edit"}
      entityType={"podcast"}
      pageTitle={"Create a podcast post"}
      returnRoute={"/podcasts-creator"}
      categoryName={"podcast"}
    />
  )
}
